var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEconomy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.792,
    height: 18.391,
    viewBox: "0 0 16.792 18.391",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-22.261)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.261)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M26.459,0h-3.6a.6.6,0,0,0-.6.6V17.792a.6.6,0,0,0,.6.6h3.6a.6.6,0,0,0,.6-.6V.6A.6.6,0,0,0,26.459,0Z",
    transform: "translate(-22.261 0)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.258 9.595)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M193.415,267.13h-3.6a.6.6,0,0,0-.6.6v7.6a.6.6,0,0,0,.6.6h3.6a.6.6,0,0,0,.6-.6v-7.6A.6.6,0,0,0,193.415,267.13Z",
    transform: "translate(-189.217 -267.13)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(34.255 4.798)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M360.372,133.565h-3.6a.6.6,0,0,0-.6.6v12.394a.6.6,0,0,0,.6.6h3.6a.6.6,0,0,0,.6-.6V134.165A.6.6,0,0,0,360.372,133.565Z",
    transform: "translate(-356.174 -133.565)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEconomy);
export default __webpack_public_path__ + "static/media/economy.725635f600a0dbb5ea3bdc9b77961226.svg";
export { ForwardRef as ReactComponent };